import React from 'react'
import PropTypes from 'prop-types'
import { FormGroup, Checkbox } from 'react-bootstrap'

export const CheckboxField = ({ input, id, label }) => {
	return <FormGroup
		id={id}
		bsClass={'form-group mb-0'}
		{...input}
	>
		<Checkbox checked={input.value} onChange={()=>{}}>
			{label}
		</Checkbox>
	</FormGroup>
}

CheckboxField.propTypes = {
	input: PropTypes.object,
	id: PropTypes.string,
	label: PropTypes.string,
}

export default CheckboxField



// WEBPACK FOOTER //
// ./src/components/CheckboxField.js